module.exports = __webpack_public_path__ + "img/milage.50343e63.png";